module.exports = __webpack_public_path__ + "img/hr-level1_running_gun_shadow.6bd6950d.png";